///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportPaymentType = Meevo.Plugins.Reports.IReportPaymentType;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class ReportPaymentTypesCollection extends SmartMoverApiCollection<IReportPaymentType> implements IApiCollection<IReportPaymentType> {

        protected get url() {
            return 'report/PaymentType';
        }

        constructor(connectedModel: ModelValueType[], items: IReportPaymentType[] = [], options: ICollectionOptions<IReportPaymentType> = {}) {
            super(connectedModel, items, options);
            this.updateCriteria({
                objectStateEnumList: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
            });
        }

    }

}